import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { notificationInit } from '../../modules/notifications/actions';
import { getThermoboxesRequest } from '../../api/requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { DISMISS_TIME } from '../../api/constants';
import { GET_THERMOBOXES, setThermoboxesAction, setIsThermoboxesLoadingAction, setPaginationAction } from './actions';
import { errorHandler } from '../../api/utils';

export function* getThermoboxesSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsThermoboxesLoadingAction(true));
		}
		const { data, meta, message, toast } = yield call(getThermoboxesRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setThermoboxesAction(
					data?.map(thermobox => ({
						...thermobox,
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=thermobox&id=${thermobox.id}`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsThermoboxesLoadingAction(false));
	}
}

export default function* thermoboxesContainerSaga() {
	yield takeEvery(GET_THERMOBOXES, getThermoboxesSaga);
}
